import { CreditCard } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useBillingRequiredStore } from '@/store/useBillingRequiredStore';

export function BillingRequiredDialog() {
  const navigate = useNavigate();
  const { isOpen, message, close } = useBillingRequiredStore();

  const handleRedirect = () => {
    close();
    navigate({ to: '/organization/settings/billing' });
  };

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      <AlertDialogContent className="border border-purple-500/30 bg-background/95">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-3 text-lg font-semibold text-foreground">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-purple-500/10 text-purple-950 dark:text-purple-50">
              <CreditCard className="h-5 w-5" />
            </span>
            Billing Action Needed
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground">
            {message ||
              'It looks like your organization needs to update billing before continuing. Head over to billing to get back on track.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={close} className="border-white/10">
            Not now
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleRedirect}
            className="bg-purple-500 text-white hover:bg-purple-600"
          >
            Go to billing
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
